import * as $swal from "sweetalert2";

const moment = require('moment-jalaali')
const Emitter = require('tiny-emitter');
const crypto = require('crypto')
const axios = require('axios')

const cookie_setting = "stg-vister";
const storage_path = "qti-vister";
const forms_path = "bakt-vister";
const login_mode = 'login-mode'

const base_url = 'https://api.visternet.com/'
const emitter = new Emitter();

let oracle = {
    CONTRACT: 'CONTRACT',
    REFRESH: 'REFRESH',
    UPDATE: 'UPDATE',
    send(key, args) {
        emitter.emit(key, args);
    }, receive(key, func) {
        emitter.on(key, (args) => {
            func(args);
        });
    }, isEmail(phrase) {
        return phrase != null && phrase.length > 0 && phrase.includes('@')
    }, saveToClipboard(text) {
        if (window.clipboardData && window.clipboardData.setData) {
            return window.clipboardData.setData("Text", text);
        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            let textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");
            } catch (ex) {
                return prompt("Copy to clipboard: Ctrl+C, Enter", text);
            } finally {
                document.body.removeChild(textarea);
            }
        }
    }, getUnregisteredForms() {
        let data = this.getData(forms_path)
        if (data == null || data.trim().length == 0) {
            return [];
        }
        let array = data.split(",");
        if (array == null) {
            array = [];
        }
        return array;
    }, addUnregisteredForm(id) {
        if (this.isLoggedIn()) {
            return
        }
        let array = this.getUnregisteredForms();
        array.push(id);
        this.setData(forms_path, array.join(","))
    }, removeForms() {
        this.setData(forms_path, null)
    }, MD5(data) {
        if (this.isEmpty(data)) return null
        return crypto.createHash('md5').update(data).digest('hex')
    }, isEN() {
        let lang = oracle.getData("lang");
        return lang == null || lang.toLowerCase() == "en";
    }, isMobile() {
        return window.screen.width < 700;
    }, date(date) {
        if (this.isEN()) return moment(date).format('jYYYY-jMM-jDD HH:mm')
        else return moment(date).format('HH:mm jDD-jMM-jYYYY')
    }, format(number) {
        if (number == null) {
            return "";
        }
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatMinutes(seconds) {
        return new Date(seconds * 1000).toISOString().substring(14, 19)
    }, encode(object) {
        if (object == null) {
            return null;
        }
        return encodeURIComponent(JSON.stringify(object));
    }, decode(object) {
        if (object == null) {
            return null;
        }
        return JSON.parse(decodeURIComponent(object));
    }, setToken(request) {
        this.setData(storage_path, request, true);
    }, getToken() {
        return this.getData(storage_path, true);
    }, isLoggedIn() {
        let data = this.getToken()
        return data != null && data.length > 0
    }, getData(key, secure) {
        let token = localStorage.getItem(key);
        if (token != null && token.length > 0) {
            if (!secure) {
                return JSON.parse(decodeURIComponent(token));
            } else {
                return atob(token);
            }
        }
        let name = key + "=";
        let data = document.cookie.split(";");
        for (let i = 0; i < data.length; i++) {
            let c = data[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                if (!secure) {
                    return JSON.parse(decodeURIComponent(c.substring(name.length, c.length)));
                } else {
                    return atob(c.substring(name.length, c.length));
                }
            }
        }
        return null;
    }, copy(model) {
        return model == null ? null : JSON.parse(JSON.stringify(model));
    }, setData(key, value, secure) {
        let data = "";
        if (value != null) {
            if (secure != null && secure) {
                data = btoa(value)
            } else {
                data = encodeURIComponent(JSON.stringify(value))
            }
        }
        localStorage.setItem(key, data);
        if (!secure) {
            return;
        }
        let date = new Date();
        date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
        let expires = "expires=" + date.toUTCString();
        document.cookie = key + "=" + data + ";" + expires + ";path=/";
    }, newTab(link) {
        window.open(link, '_blank').focus();
    }, isEmpty(data) {
        if (typeof data === "boolean") {
            return false;
        }
        if (data != null && Array.isArray(data) && data.length == 0) {
            return true;
        }
        if (data == null || (data == '' && data != 0)) {
            return true;
        }
        if (this.isString(data)) {
            return data.trim().length == 0
        }
        return false
    }, isString(variable) {
        return (typeof variable === 'string' || variable instanceof String)
    }, isLawyer() {
        let mode = this.getData(login_mode)
        return mode != null && mode == 'lawyer'
    }, setLawyer(flag) {
        this.setData(login_mode, flag ? 'lawyer' : 'user')
    }, logOut() {
        let date = new Date();
        date.setTime(date.getTime() - 100 * 24 * 60 * 60 * 1000);
        let expires = "expires=" + date.toUTCString();
        document.cookie = storage_path + "=;" + expires + ";path=/";
        localStorage.removeItem(cookie_setting);
        localStorage.removeItem(storage_path);
        if (this.isLawyer() || window.location.href.endsWith("accounts")) {
            window.location.href = "/accounts/login";
        } else {
            window.location.href = "/login";
        }
    }, showMessage(message, action, lambda, resource) {
        $swal.fire({
            html: '<p class="mr-3 ml-3 ' + (this.isEN() ? "dir" : "dirFa") + '">' + message + '</p>',
            showCloseButton: true,
            showConfirmButton: action != null,
            confirmButtonText: '<p class="' + (this.isEN() ? "dir" : "dirFa") + ' font-weight-bold' + '" style="text-align: center !important; margin-top: auto; margin-bottom: auto;">' + action + '</p>',
            imageUrl: (resource != null ? require("@/assets/image/" + resource + ".png") : (lambda == null ? require("@/assets/image/error.png") : null)),
            imageWidth: 70,
            imageHeight: 70,
            customClass: {
                popup: 'format'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                if (lambda != null) {
                    lambda()
                }
            }
        })
    }, axios(url, data, onSuccess, onError, onProgress, extra) {
        axios({
            method: 'post',
            url: base_url + url,
            headers: {
                "Accept-Language": this.isEN() ? "en" : "fa",
                'Authorization': this.getToken(),
                'Content-Type': 'application/json;charset=UTF-8'
            },
            data: data,
            timeout: 30000,
            onDownloadProgress: function (progressEvent) {
                if (onProgress != null) {
                    onProgress(progressEvent)
                }
            },
        }).then(function (response) {
            if (response != null && response.data != null && response.data.success != null && response.data.success) {
                if (response.headers != null && response.headers['authorization'] != null) {
                    oracle.setToken(response.headers['authorization'])
                } else if (response.headers != null && response.headers['Authorization'] != null) {
                    oracle.setToken(response.headers['Authorization'])
                }
                if (onSuccess != null) {
                    if (extra != null) {
                        onSuccess(response.data, extra);
                    } else {
                        onSuccess(response.data);
                    }
                }
            } else {
                handleError(response != null ? response : null, onError)
            }
        }).catch(function (error) {
            handleError(error != null && error.response != null ? error.response : null, onError)
        });
    }, axiosUpload(data, onSuccess, onError, onProgress, customName) {
        let formData = new FormData()
        if (customName != null) {
            formData.append("file", data, customName)
        } else {
            formData.append("file", data)
        }
        axios({
            method: 'post',
            url: base_url + "file/upload",
            data: formData,
            headers: {
                "Accept-Language": this.isEN() ? "en" : "fa",
                'Authorization': this.getToken(),
                'Content-Type': 'multipart/form-data'
            },
            timeout: 120000,
            onDownloadProgress: function (progressEvent) {
                if (onProgress != null) {
                    onProgress(progressEvent)
                }
            },
            onUploadProgress: function (progressEvent) {
                if (onProgress != null) {
                    onProgress(progressEvent);
                }
            }
        }).then(function (response) {
            if (response != null && response.data != null && response.data.success != null && response.data.success == true) {
                if (onSuccess != null) {
                    onSuccess(response.data)
                }
            } else {
                handleError(response != null ? response : null, onError)
            }
        }).catch(function (error) {
            handleError(error != null && error.response != null ? error.response : null, onError)
        });
    }
}

function handleError(param, onError) {
    if (param != null && param.data != null) {
        param = param.data
    }
    if (onError != null) {
        onError(param)
        return;
    }
    if (param != null && param.status != null && param.status == 401) {
        oracle.logOut()
        return
    }
    if (param != null && param.message != null) {
        oracle.showMessage(param.message)
    }
}

export default oracle
export const dev_mode = true
export const globals = {}
